import pagination from "./pagination"


pagination.install = function(Vue) {
    Vue.component(pagination.name, pagination);
}

export default pagination
